import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Card, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { createRestaurant, fetchRestaurantDetails } from "../actions/restaurantActions";
import { logout } from "../actions/userActions";
import RestaurantCreation from "../screens/RestaurantCreation";
import { CustomModal } from "./CustomModal";
import { ConfirmationModal } from "./ConfirmationModal";
const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
const StyledCard = styled(Card)`
  margin: 0 0 20px;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  background: #fff;
`;
const CardTop = styled.div`
  min-height: 44px;
  padding: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
`;
const StyledRow = styled(Row)`
  height: 100%;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  gap: 12px;
  flex-wrap: nowrap;
  > :first-child { flex: 1 1 auto; width: auto; min-width: 0; }
  > :last-child { flex: 0 0 auto; width: auto; }
`;
const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: ${props => props.justify ? props.justify : "start"};
  padding: 0;
`;
const StyledColForIcons = styled(Col)`
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #ee754c;
  padding: 0;

  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;

  @media (max-width: 576px) {
    font-size: 19px;
    line-height: 1.1;
  }
`;
const Smallh6 = styled.h6`
  font-size: 0.9rem;
  margin: 0;
  color: #faf6e9;
  font-weight: bold;

  @media (max-width: 576px) {
    font-size: 11px;
  }
`;
const StyledButton = styled.button`
  min-height: 40px;
  background-color: #ee754c;
  color: white;
  border: none;
  border-radius: 9px;
  padding: 9px 14px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;

  &:hover {
    background-color: #7e9895;
    box-shadow: 0 5px 14px rgba(75, 51, 53, 0.12);
    transform: translateY(-1px);
  }
  &:active {
    background-color: #6a837f;
    box-shadow: none;
    transform: translateY(0);
  }
  &:disabled {
    background-color: #ccd4d3;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    padding: 8px;
    font-size: 13px; /* texto menor */
    display: inline-flex; /* mantém conteúdo na mesma linha */
    align-items: center;
    gap: 6px;
    white-space: nowrap; /* evita quebra para a 2ª linha */
    flex-shrink: 0; /* não encolhe abaixo do conteúdo */
  }
`;
const FirstRestaurantExitButton = styled.button`
  padding: 6px 11px;
  border: 1px solid #eadfd9;
  border-radius: 8px;
  background: #fff7f3;
  color: #d9603b;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: #fff0e9;
    border-color: #ee754c;
    color: #ee754c;
  }

  &:focus-visible {
    outline: 2px solid #ee754c;
    outline-offset: 2px;
  }
`;
function RestaurantsHeader() {
  const {
    t
  } = useTranslation();
  const firstOption = ["Seguir tutorial", "Ao criar o restaurante com o tutorial ativado, explicamos como configurar todas as opções ao seu gosto."];
  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(firstOption);
  const [showHeader, setShowHeader] = useState(true);
  const [showFirstRestaurantLogoutConfirm, setShowFirstRestaurantLogoutConfirm] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const restaurant_sub = useSelector(state => state.restaurant_subscription);
  const {
    restaurantSubscription
  } = restaurant_sub;
  const manager_info = useSelector(state => state.crudManager);
  const {
    managerInfo
  } = manager_info;
  const restaurantList = useSelector(state => state.restaurantList);
  const {
    restaurants,
    isLoading,
    error
  } = restaurantList;
  useEffect(() => {
    if (Array.isArray(restaurants) && restaurants.length === 0) {
      setShowModal(true);
    }
  }, [restaurants]);
  const handleCreateRestaurant = () => {
    dispatch(createRestaurant("reset", true));
    dispatch(fetchRestaurantDetails("reset", true));
    if (selectedOption[0] === firstOption[0]) {
      navigate(`/restaurant_creation/${"yes"}/${"null"}/${"null"}`);
    } else {
      navigate(`/restaurant_creation/${"no"}/${"null"}/${"null"}`);
    }
  };
  const isFirstRestaurant = Array.isArray(restaurants) && restaurants.length === 0;
  const handleLogout = () => {
    setShowFirstRestaurantLogoutConfirm(false);
    dispatch(logout(navigate));
  };
  return <StyledCard className="p-0">
      {showHeader ? <>
          {restaurantSubscription && showHeader ? <CardTop>
              <StyledRow>
                <StyledColForIcons xs={6}>{t("ui.components.restaurantsHeader.restaurantes")}</StyledColForIcons>
                <StyledCol xs={6} justify="flex-end">
                  <ActionButtons>
                    {showHeader && managerInfo?.boss === managerInfo?.user && <StyledButton onClick={() => setShowModal(true)}>
                        <Smallh6>{t("ui.components.restaurantsHeader.novoRestaurante")}<FontAwesomeIcon size="lg" icon={faPlus} style={{
                    color: "#FAF6E9"
                  }} className="ml-2" />
                        </Smallh6>
                      </StyledButton>}
                  </ActionButtons>
                </StyledCol>
              </StyledRow>
            </CardTop> : <CardTop>
              <StyledRow>
                <StyledCol xs={12}>{t("ui.components.restaurantsHeader.aplicacaoEmDesenvolvimentoMantenhaSeA")}</StyledCol>
              </StyledRow>
            </CardTop>}
        </> : null}

      <CustomModal
        title={isFirstRestaurant ? t("ui.i18nCleanup2.criaOTeuPrimeiroRestaurante") : t("ui.components.restaurantsHeader.novoRestaurante")}
        show={showModal}
        onHide={isFirstRestaurant ? () => {} : () => setShowModal(false)}
        removeCloseButton={isFirstRestaurant}
        keyboard={!isFirstRestaurant}
        centered={false}
        headerAction={isFirstRestaurant ? (
          <FirstRestaurantExitButton
            type="button"
            onClick={() => setShowFirstRestaurantLogoutConfirm(true)}
          >
            {t("ui.components.header.sair")}
          </FirstRestaurantExitButton>
        ) : null}
      >
        <RestaurantCreation setRestauranteCreationModal={setShowModal} />
      </CustomModal>

      <ConfirmationModal
        show={showFirstRestaurantLogoutConfirm}
        onHide={() => setShowFirstRestaurantLogoutConfirm(false)}
        onConfirm={handleLogout}
        title={t("ui.components.restaurantsHeader.firstRestaurantExitTitle")}
        body={t("ui.components.restaurantsHeader.firstRestaurantExitBody")}
        confirmLabel={t("ui.components.restaurantsHeader.firstRestaurantExitConfirm")}
        cancelLabel={t("common.cancel")}
        confirmColor="#ee754c"
        cancelColor="#99b0ad"
      />
    </StyledCard>;
}
export default RestaurantsHeader;
